import { apiService } from "../axiosService";

export const getAuditPerforms = async (filters) => {
  // filters = { app_id, wf_id, instance_id, activity_id, user_email, status, from_date, to_date, page, limit }
  const response = await apiService.get(`/audit/performs`, { params: filters });
  return response;
};

export const getAuditTrace = async (traceId) => {
  const response = await apiService.get(`/audit/traces/${traceId}`);
  return response;
};

export const getAuditFilters = async (params) => {
  // params = { app_id, wf_id }
  const response = await apiService.get(`/audit/filters`, { params });
  return response;
};

export const getAuditExportRuns = async (params) => {
  // params = { limit }
  const response = await apiService.get(`/audit/export/runs`, { params });
  return response;
};

export const triggerAuditExportRun = async (appId) => {
  const response = await apiService.post(`/audit/export/run`, {}, { params: appId ? { app_id: appId } : {} });
  return response;
};

export const getAppWorkflows = async (appId) => {
  // workflows + subject-field candidates from the builder config (available
  // before any export has run)
  const response = await apiService.get(`/audit/app-workflows`, { params: { app_id: appId } });
  return response;
};

export const resetAuditExportRuns = async () => {
  const response = await apiService.post(`/audit/export/reset`, {});
  return response;
};

export const getSubjectConfig = async (wfId) => {
  const response = await apiService.get(`/audit/subject-config`, { params: { wf_id: wfId } });
  return response;
};

export const getSubjectConfigs = async () => {
  const response = await apiService.get(`/audit/subject-configs`);
  return response;
};

export const saveSubjectConfig = async (payload) => {
  // payload = { app_id, fields: [{ label, field_id } x3] }
  const response = await apiService.put(`/audit/subject-config`, payload);
  return response;
};
